import { render, staticRenderFns } from "./addCadastralOvamVlaremActModal.vue?vue&type=template&id=22b495fd&scoped=true"
import script from "./addCadastralOvamVlaremActModal.vue?vue&type=script&lang=js"
export * from "./addCadastralOvamVlaremActModal.vue?vue&type=script&lang=js"
import style0 from "./addCadastralOvamVlaremActModal.vue?vue&type=style&index=0&id=22b495fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b495fd",
  null
  
)

export default component.exports